export default {
  data() {
    return {
      buyoutCheckLoading: false,
      buyoutCheckPassed: false,
      buyoutCheckPopupVisible: false,
      buyoutCheckPopupMode: null,
      buyoutCheckResponse: null,
      buyoutCheckDeviceId: null,
    };
  },
  computed: {
    buyoutCheckDays() {
      const days = Number(this.user?.buyoutCheckDays);
      return Number.isFinite(days) ? days : 0;
    },
    buyoutCheckPopupTitle() {
      return this.buyoutCheckPopupMode === 'recent_buyout_blocked'
        ? 'Повторный выкуп недоступен'
        : 'Сервис проверки недоступен';
    },
    buyoutCheckPopupMessage() {
      if (this.buyoutCheckPopupMode === 'recent_buyout_blocked') {
        const daysLimit = this.buyoutCheckResponse?.daysLimit || this.buyoutCheckDays;
        const daysUntilUnlock = this.buyoutCheckResponse?.daysUntilUnlock ?? 0;

        return `Данное устройство было выкуплено менее ${daysLimit} дней назад и на данный момент его выкуп не возможен. Попробуйте повторно выкупить через ${daysUntilUnlock} дней.`;
      }

      return 'Не удалось выполнить проверку устройства на повторный выкуп - сервис проверки временно недоступен. Вы можете закрыть это окно, начать выкуп заново или продолжить определение устройства на свой риск.';
    },
  },
  methods: {
    openBuyoutCheckPopup(mode, response) {
      this.buyoutCheckPopupMode = mode;
      this.buyoutCheckResponse = response;
      this.buyoutCheckPopupVisible = true;
    },
    closeBuyoutCheckPopup() {
      this.buyoutCheckPopupVisible = false;
      this.buyoutCheckPopupMode = null;
      this.buyoutCheckResponse = null;
    },
    resetBuyoutCheckState() {
      this.buyoutCheckPassed = false;
      this.buyoutCheckDeviceId = null;
      this.closeBuyoutCheckPopup();
    },
    markBuyoutCheckPassed(deviceId) {
      this.buyoutCheckPassed = true;
      this.buyoutCheckDeviceId = deviceId;
      this.closeBuyoutCheckPopup();
    },
    async ensureBuyoutCheckPassed(deviceId) {
      const normalizedDeviceId = String(deviceId || '').trim();

      if (!normalizedDeviceId || this.buyoutCheckDays <= 0) {
        return true;
      }

      if (this.buyoutCheckPassed && this.buyoutCheckDeviceId === normalizedDeviceId) {
        return true;
      }

      if (this.buyoutCheckLoading) {
        return false;
      }

      this.buyoutCheckLoading = true;

      try {
        const response = await this.startBuyoutCheck({
          deviceId: normalizedDeviceId
        });

        if (response?.canStart === true) {
          this.markBuyoutCheckPassed(normalizedDeviceId);
          return true;
        }

        if (response?.error === 'buyout_check_unavailable' || response?.status === 503) {
          this.openBuyoutCheckPopup('buyout_check_unavailable', response);
          return false;
        }

        if (response?.canStart === false) {
          this.openBuyoutCheckPopup('recent_buyout_blocked', response);
          return false;
        }

        if (typeof this.onBuyoutCheckError === 'function') {
          this.onBuyoutCheckError(response?.message || 'Не удалось выполнить проверку повторного выкупа. Попробуйте еще раз.');
        }

        return false;
      } finally {
        this.buyoutCheckLoading = false;
      }
    },
  },
};
